import * as React from 'react';
import { PVAActionsButton, PVAActionsButtonGroup } from '../reports/blocks/PVAActionsButton';
import {PrivacyPolicy} from "../PrivacyPolicy";
import './PVAPage.css';


interface PVAPageHeaderProps {
    title?: string | React.ReactNode;
    actions?: PVAActionsButtonGroup[];
    actionsDisabled?: boolean;
    preventInteraction?: boolean;
}

export class PVATitleText extends React.Component {
    public render() {
        return (
            <div className="text" style={{ display: 'flex', alignItems: 'center' }}>
                {this.props.children}
            </div>
        );
    }
}

export class PVATitle extends React.Component {
    public static Text = PVATitleText;

    public render() {
        return (
            <div className="title">
                {this.props.children}
            </div>
        );
    }
}

export class PVAHeaderButtons extends React.Component {
    public render() {
        return (
            <div className="actions">
                {this.props.children}
            </div>
        );
    }
}

export class PVAPageHeader extends React.Component<PVAPageHeaderProps> {
    public static Title = PVATitle;
    public static Buttons = PVAHeaderButtons;

    public render() {
        const { title, actions, children, actionsDisabled = false } = this.props;
        const mainChildren = React.Children.toArray(children).filter((child: any) => !child || child.type !== PVAHeaderButtons);
        const headerButtons = React.Children.toArray(children).filter((child: any) => child && child.type === PVAHeaderButtons);

        return (
                <div className={'content-header'}>
                    {title && (
                        <div className="title">
                            {title}
                        </div>
                    )}
                    {mainChildren}
                    {(actions || headerButtons.length > 0) && (
                        <PVAHeaderButtons>
                            {headerButtons}
                            {actions && <PVAActionsButton groups={actions} disabled={actionsDisabled} />}
                        </PVAHeaderButtons>
                    )}
                </div>);
    }
}

export class PVAPageBody extends React.Component<{ className?: string }> {
    public render() {
        return (
            <div className={"content-body " + (this.props.className || "")}>
                <div className="content-container">
                    {this.props.children}
                </div>
            </div>
        );
    }
}

interface PVAPageFooterProps {
    preventInteraction?: boolean;
}

export class PVAPageFooter extends React.Component<PVAPageFooterProps> {
    public render() {
        return (
            <div className="pva-page-footer">
                <div>The Pondera® Virtual Advisor is intended for use by the organization as a supplement to other
                    evaluation criteria available, including prior knowledge and performance of the individual. It is
                    not intended as the sole basis for evaluation.
                </div>
                <div>The goal of the Pondera® Virtual Advisor is to allow the user to obtain information as to a
                    particular individual's preferences or preferred operating style. When this information is combined
                    with the organization's knowledge of and experience with the individual, it can assist the
                    organization in effectively utilizing the skills, abilities, and strengths of each person to
                    increase both organizational and individual efficiency and effectiveness.
                </div>
                {!this.props.preventInteraction && <div>© Pondera Technologies LLC {(new Date()).getFullYear()} | <span className="privacy-policy-container"><PrivacyPolicy /></span></div>}
            </div>
        );
    }
}

export class PVAPage extends React.Component<{ className?: string }> {
    public static Header = PVAPageHeader;
    public static Body = PVAPageBody;
    public static Footer = PVAPageFooter;

    public render() {
        return (
            <div className={"component-PVAPage site-content-inner " + (this.props.className || "")}>
                {this.props.children}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/PVAPage.tsx